import React, { useState } from "react";

const FAQS = [
  { q: "How do I book a doctor appointment?", a: "Register as a patient, search for a doctor, choose a chamber/slot and confirm your booking. You'll receive a confirmation via SMS, email, and WhatsApp." },
  { q: "Can I book for a family member?", a: "Yes! When booking, you can add another person's name and age if the appointment is on their behalf." },
  { q: "How do online payments work?", a: "We support secure online payment at the time of booking. Refunds are processed within 5-7 business days if applicable." },
  { q: "How do I schedule a lab test?", a: "Search for a diagnostic lab, select your required tests, and choose a visit or home collection option." },
  { q: "Will I get reminders?", a: "Yes, you'll receive SMS, WhatsApp, and email notifications for all your bookings and on the day of your appointment." },
  { q: "How can doctors register?", a: "Doctors can register via the registration page. After submission, the admin will review and approve the account." },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);

  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="font-display font-bold text-3xl text-slate-900 mb-8">
        Frequently Asked Questions
      </h1>
      <div className="space-y-3">
        {FAQS.map((faq, i) => (
          <div key={i} className="card">
            <button
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex items-center justify-between text-left"
            >
              <span className="font-medium text-slate-800">{faq.q}</span>
              <span className="text-slate-400 ml-4">{open === i ? "▲" : "▼"}</span>
            </button>
            {open === i && (
              <p className="mt-3 pt-3 border-t border-slate-100 text-slate-600 text-sm">
                {faq.a}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
